import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    label: 'Soluciones',
    href: '#soluciones'
  }, {
    label: 'Seguridad',
    href: '#seguridad'
  }, {
    label: 'Casos de uso',
    href: '#casos-uso'
  }, {
    label: 'Contacto',
    href: '#contacto'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy-900/80 backdrop-blur-lg border-b border-teal-500/10' : 'bg-transparent'}`} data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-190">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-191">
            <a href="#" className="flex items-center group" data-id="element-192">
              <img src="https://cdn.magicpatterns.com/uploads/4uYFjyswBHJgHa3j3GEUbF/tru_Id_fondonegro.png" alt="TruID" className="h-8 md:h-10 w-auto" data-id="element-193" />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-194">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-gray-300 hover:text-teal-500 transition-colors text-sm font-medium" data-id="element-195">
                {link.label}
              </a>)}
            <a href="https://app.truid.org" target="_blank" rel="noopener noreferrer" className="bg-teal-500 hover:bg-teal-600 text-white px-6 py-2.5 rounded-lg font-medium transition-colors" data-id="element-196">
              Acceso a Mi Identidad Digital
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-197">
            {isMobileMenuOpen ? <X size={24} data-id="element-198" /> : <Menu size={24} data-id="element-199" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="md:hidden bg-navy-800 border-t border-teal-500/10" data-id="element-200">
            <div className="px-4 py-6 space-y-4" data-id="element-201">
              {navLinks.map(link => <a key={link.label} href={link.href} className="block text-gray-300 hover:text-teal-500 transition-colors font-medium" onClick={() => setIsMobileMenuOpen(false)} data-id="element-202">
                  {link.label}
                </a>)}
              <a href="https://app.truid.org" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-teal-500 hover:bg-teal-600 text-white px-6 py-3 rounded-lg font-medium transition-colors" data-id="element-203">
                Acceso a Mi Identidad Digital
              </a>
            </div>
          </div>}
      </div>
    </nav>;
}